<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
        <v-card-title>
            FISHCAR
        </v-card-title>
        <v-card-text>
             <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                v-model="fishcar.name"
                label="Name *"
                :rules="textRules"
                required
                ></v-text-field>

                <v-text-field
                v-model="fishcar.contact_no"
                label="Contact No. *"
                ></v-text-field>
                
                <v-text-field
                v-model="fishcar.address"
                label="Address"
                ></v-text-field>
                <v-text-field
                v-model="fishcar.commission"
                label="(%) Commission"
                ></v-text-field>
                <v-select
                v-model="fishcar.status"
                :items="['active', 'delete']"
                label="Status"
            ></v-select>
             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="default" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    fishcar: {
        type: Object,
        default: ()=>{ return {}}
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      }
  },
  watch: {
    // show () {
    //   if (this.show == false) {
    //   }
    // }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.emitToParent(this.state)
        }
      },
    emitToParent (action) {
    if(this.fishcar.status == "delete") {this.fishcar.status = 'deleted'}
      this.$emit('DialogEvent', {action: action, fishcar:this.fishcar})
    }
  }
}
</script>
